import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/equivalent-annual-annuity-calculator',
  component: () => import('../../routes/EquivalentAnnualAnnuity.svelte'),
  card: {
    id: 'equivalent-annual-annuity',
    title: 'Equivalent Annual Annuity Calculator',
    description: 'Convert project cash flows into equivalent annual payments to compare projects with different lifespans.',
    icon: 'sync_alt',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/equivalent-annual-annuity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Equivalent Annual Annuity Calculator – Compare Projects of Different Lifespans',
    description: 'Free Equivalent Annual Annuity (EAA) calculator to compare mutually exclusive projects with different lifespans. Converts NPV into constant annual payments for fair comparison.',
  },
};

export default meta;
